import React, { useEffect, useRef, useState } from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import DataAPI from '../../api/DataApi';
import { Nullable } from 'primereact/ts-helpers';
import { InputText } from 'primereact/inputtext';
import { Link, useNavigate } from 'react-router-dom';
import UserDashboardCardComponent from '../../components/usersComponents/UserDashboardCardComponent';
import Utilidades from '../../services/Utilidades';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { Card } from 'primereact/card';
import { FileUpload, FileUploadHeaderTemplateOptions, FileUploadSelectEvent, FileUploadUploadEvent, ItemTemplateOptions,} from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Message } from 'primereact/message';

function CertificatesView() {
    const navigate = useNavigate();
    const [date1, setDate1] = useState(new Date());
    const [date2, setDate2] = useState(new Date());
    const [iniciando, setIniciando] = useState(true);
    const [cargando, setCargando] = useState(false);
    const [companies, setCompanies] = useState<Array<any>>([]);
    const [serviceCertificates, setServiceCertificates] = useState<Array<any>>([]);
    const [filterCompanies, setFilterCompanies] = useState<Array<any>>([]);
    const [emptyTableLabel , setEmptyTableLabel] = useState('Cargando...');
    const [msgError , setMsgError] = useState('Error al usar el certificado.');
    
    // const [searchValue, setSearchValue] = useState('');
    const [grupos, setGrupos] = useState<Array<any>>([]);
    const [visible, setVisible] = useState(false);
    const [nuevoReg, setNuevoReg] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [itemReg, setItemReg] = useState<any>({id:0, name: '', creationDate: new Date(), dueDate: new Date()});
    const [sendCertificate, setSendCertificate] = useState(false);

    const [totalSize, setTotalSize] = useState(0);
    const fileUploadRef = useRef<FileUpload>(null);

    const [Keyvalue, setKeyValue] = useState('');
    const [checkingCertificate, setCheckingCertificate] = useState(false);
    const [errorInCertificate, setErrorInCertificate] = useState(false);
    const [successInCertificate, setSuccessInCertificate] = useState(false);

    const datos = [
        {
            'document' : 'E310000000001',
            'date' : '29/09/2024',
            'status' : 'Aceptado',
            'amount' : '1200.00',
            'options' : '',
        }
    ];

    const footerContent = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisible(false)} 
                className="text-slate-400" autoFocus text />
            <Button label={ guardando ? 'Guardando' : 'Guardar' } size='small' 
                icon="pi pi-save" className='web-boton' disabled={guardando || (sendCertificate && !successInCertificate)} 
                onClick={guardarDatos}  
                />
        </div>
    );
    
    const statusBodyTemplate = (item:any) => {
        if (item.dueDays === 999999)
            return <Tag className='bg-black' value={'No Definido'} severity={'info'}></Tag>;
        else if ( item.dueDays <= 0 )
            return <Tag className='bg-red-700' value={'Inactivo'} severity={'danger'}></Tag>;
        else if ( item.dueDays <= 7)
            return <Tag value={'Venciendo'} severity={'warning'}></Tag>;
        else if ( item.dueDays > 7)
            return <Tag className='bg-green-700' value={'Activo'} severity={'danger'}></Tag>;
        else 
            return <Tag className='bg-black' value={'Inactivo'} severity={'info'}></Tag>;
    };

    const optionsTemplate = (item:any) => {
        if (item.dueDays === 999999)
            return (
            <div className='space-x-3 flex text-xs items-center'>
                <Button icon="pi pi-save" text aria-label="data" 
                    className='p-0 h-5 w-6 button-table' tooltip='Agregar Información'
                    onClick={() => { prepararDatos(item) } }
                />
            </div>
        );
        else 
            return (
            <div className='space-x-3 flex text-xs items-center'>
                <Button icon="pi pi-refresh" text aria-label="data" 
                    className='p-0 h-5 w-6 button-table' tooltip='Actualizar Información'
                    onClick={() => { prepararDatos(item) } }
                >&nbsp;Actualizar</Button>
            </div>
        );
    };

    const statusBodyTemplate2 = (dueDays:number) => {
        if ( dueDays <= 0 )
            return <Tag className='bg-red-700' value={'Inactivo'} severity={'danger'}></Tag>;
        else if ( dueDays <= 7)
            return <Tag value={'Venciendo'} severity={'warning'}></Tag>;
        else if ( dueDays > 7)
            return <Tag className='bg-green-700' value={'Activo'} severity={'danger'}></Tag>;
        else 
            return <Tag className='bg-black' value={'Inactivo'} severity={'info'}></Tag>;
    };

    const formatCurrency = (value:any) => {
        return value.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const formatDate = (value:any) => {
        if (value.creationDate != null) 
            return Utilidades.getStringOfDateShort(new Date(value.creationDate));
        else 
            return '';
    };
    const formatDate2 = (value:any) => {
        if (value.dueDate != null) 
            return Utilidades.getStringOfDateShort(new Date(value.dueDate));
        else 
            return '';
    };

    const formatDias = (value:any) => {
        if (value.dueDays != null){
            if  (value.dueDays === 999999)
                return '';
            else 
                return Number(value.dueDays).toString() + ' Día' + (value.dueDays > 1 ? 's': '');
        } else 
            return '';
    };

    const nameTemplate = (value:any) => {
        return (
            <div>
                { value.name }
            </div>
        );
    };

    const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
        const { className, chooseButton } = options;
        // const value = totalSize / 10240 * 100.0;
        
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {/* {uploadButton} */}
                {/* {cancelButton} */}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue}</span>
                    {/* <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar> */}
                </div>
            </div>
        );
    };

    const itemTemplate = (inFile: object, props: ItemTemplateOptions) => {
        const file = inFile as File;
        return (
            <div className="flex align-items-center flex-wrap" style={{ padding: 8}}>
                <div className="flex items-center " style={{ width: '80%' }}>
                    {/* @ts-ignore */}
                    {/* <img alt={file.name} role="presentation" src={file.objectURL} width={100} /> */}
                    <span className="flex flex-col text-left ml-1  w-full justify-between">
                        {file.name}
                        <small className='text-gray-400'>{new Date(file.lastModified).toLocaleDateString('en-GB')}</small>
                    </span>
                </div>
                <Button type="button" icon="pi pi-times" 
                    style={{ width: 35, height: 35 }}
                    tooltip='Eliminar'
                    className="p-button-outlined p-button-rounded p-button-danger ml-auto" 
                    onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex items-center">
                <i className="pi pi-file-plus p-3" style={{ fontSize: '2em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.1em', color: 'var(--text-color-secondary)' }} className="">
                    Arrastrar y soltar archivo aquí
                </span>
            </div>
        );
    };

    const chooseOptionsn = ()=> { 
        return (
            <Button />
        );
    };
    const chooseOptions = { icon: 'pi pi-fw pi-file-plus', iconOnly: false, className: 'web-boton p-button p-button p-2 text-xs' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    const onTemplateSelect = (e: FileUploadSelectEvent) => {
        // setTotalSize(0);
        setSuccessInCertificate(false);
        let _totalSize = 0; //totalSize;
        let files = e.files;

        for (let i = 0; i < files.length; i++) {
            _totalSize += files[i].size || 0;
        }

        setTotalSize(_totalSize);
    };

    const onTemplateUpload = (e: FileUploadUploadEvent) => {
        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
    };

    const onTemplateRemove = (file: File, callback: Function) => {
        setSuccessInCertificate(false);
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setSuccessInCertificate(false);
        setTotalSize(0);
    };

    useEffect(() => {
        if ( iniciando ) {
            setEmptyTableLabel('Cargando...');
            setIniciando(false);
            setCargando(true);
            let token: string = String(localStorage.getItem('token'));
            
            DataAPI.getCertificates(token).then((data:any) =>{
                setServiceCertificates(data.objeto);
                setCargando(false);
            });

            cargarCertificadosClientes();
        }    
    }, [cargando, iniciando]);
    


    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>Certificados</p>
                <div>
                    <div className='font-bold text-lg'>API de Servicios</div>
                    <div>
                        <ul className='mt-0 w-full ml-0'>
                            {
                                serviceCertificates.map((data) => {
                                    return (
                                    <li id={"service_cert_" + data.id} key={"service_cert_" + data.id} className='w-full ml-0 pt-1'>
                                        <div className='grid grid-cols-3 sm:grid-cols-12 gap-1 w-full'>
                                            <div className='col-span-3 sm:col-span-7 font-bold'>{data.description}</div>
                                            <div className='sm:col-span-2'>{ Utilidades.getStringOfDateShort(new Date(data.dueDate))}</div>
                                            <div>{statusBodyTemplate2(data.dueDays)}</div>
                                            <div className='sm:col-span-2 text-right'>{data.dueDays} D&iacute;as</div>
                                        </div>
                                    </li> );
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className='font-bold text-lg'>Firmas Digitales</div>
                <div className='grid grid-cols-2 md:grid-cols-4 mb-3 gap-3'>
                    <UserDashboardCardComponent text={'Vencidas'} color={'red'} value={grupos[1]} icon={'cloud_off'} />                                        
                    <UserDashboardCardComponent text={'Venciendo'} color={'orange'} value={grupos[2]} icon={'cloud'} />                                        
                    <UserDashboardCardComponent text={'Activas'} color={'green'} value={grupos[3]} icon={'cloud_done'} />                                        
                    <UserDashboardCardComponent text={'No Definidas'} color={'black'} value={grupos[0]} icon={'close'} />                                        
                </div>
                <div className='flex flex-row items-center'>
                    <i className='pi pi-search text-slate-400 absolute ml-5 select-none'></i>
                    <InputText id='TBbusqueda' name='TBbusqueda'
                        onChange={handleChange} 
                        className='w-full pl-10' placeholder='Buscar Cliente'
                        />
                </div>
                <div className="card mt-4 select-none text-xs hidden lg:block">
                    <DataTable value={filterCompanies} stripedRows
                        emptyMessage = {emptyTableLabel} >
                        {/* <Column field="name" header="Nombre"></Column> */}
                        <Column body={nameTemplate} header="Nombre"></Column>
                        <Column body={formatDate} header="Fec. Inicio"></Column>
                        <Column body={formatDate2} header="Fec. Fin"></Column>
                        <Column body={statusBodyTemplate} header="Estado"></Column>
                        <Column body={formatDias} header="Dias"></Column>
                        <Column body={optionsTemplate} header="Opciones"></Column>
                    </DataTable>
                </div>
                <div className="card mt-4 select-none text-xs lg:hidden">
                    <DataTable value={filterCompanies} stripedRows
                        emptyMessage = {emptyTableLabel} size='small' >
                        {/* <Column field="name" header="Nombre"></Column> */}
                        <Column body={nameTemplate} header="Nombre"></Column>
                        {/* <Column body={formatDate2} header="Fec. Fin"></Column> */}
                        <Column body={statusBodyTemplate} header="Estado"></Column>
                        <Column body={formatDias} header="Dias"></Column>
                        <Column body={optionsTemplate} header="Opciones"></Column>
                    </DataTable>
                </div>
            </div>
            {/* <Dialog header="Datos del Certificado" headerClassName='web-dialog-header' visible={visible} className='w-11/12 md:w-auto' 
                    onHide={() => {if (!visible) return; setVisible(false); }} 
                    footer={footerContent} closeOnEscape={false}>
                <div className='px-1'>
                    <p><b>Empresa: { itemReg.name }</b></p>
                    <div className='flex flex-col md:flex-row gap-8'>
                        <div className='flex flex-col gap-1 w-full md:w-1/2'>
                            <p className='my-0'>Fecha Inicio</p>
                            <Calendar inputId='fdesde' name='fdesde' value={date1} 
                                onChange={(e:any) => setDate1(e.value)} 
                                dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px] col-span-2'  />
                        </div>
                        <div className='flex flex-col gap-1 w-full md:w-1/2'>
                            <p className='my-0'>Fecha Expiraci&oacute;n</p>
                            <Calendar inputId='fhasta' name='fhasta' value={date2} 
                                onChange={(e:any) => setDate2(e.value)} 
                                dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px] col-span-2'  />
                        </div>
                    </div>
                </div>
            </Dialog> */}
            <Dialog header="Datos del Certificado" headerClassName='web-dialog-header' visible={visible} className='w-11/12 md:w-auto' 
                    onHide={() => {if (!visible) return; setVisible(false); }} 
                    footer={footerContent} closeOnEscape={false}>
                <div className='px-1'>
                    <p><b>Empresa: { itemReg.name }</b></p>
                    <div className='flex flex-col md:flex-row gap-8'>
                        <div className='flex flex-col gap-1 w-full md:w-1/2'>
                            <p className='my-0'>Fecha Inicio</p>
                            <Calendar inputId='fdesde' name='fdesde' value={date1} 
                                onChange={(e:any) => setDate1(e.value)} 
                                dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px] col-span-2'  />
                        </div>
                        <div className='flex flex-col gap-1 w-full md:w-1/2'>
                            <p className='my-0'>Fecha Expiraci&oacute;n</p>
                            <Calendar inputId='fhasta' name='fhasta' value={date2} 
                                onChange={(e:any) => setDate2(e.value)} 
                                dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px] col-span-2'  />
                        </div>
                    </div>
                    <div className='mt-2'>
                        <div className="flex items-center">
                            <Checkbox inputId="sendfile" name="send" value="send" onChange={() => { setSendCertificate(!sendCertificate)}} checked={sendCertificate} />
                            <label htmlFor="sendfile" className="ml-1 items-center hover:cursor-pointer">Subir Certificado</label>
                        </div>
                    </div>
                    {sendCertificate && 
                    <div>
                        <div className='mt-2' 
                            // style={{ padding: '0.5rem',
                            //     boxShadow: '0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12)',
                            //     borderRadius: '6px'
                            // }}
                        >
                            <div>
                                <FileUpload  ref={fileUploadRef} name="files" url="/api/upload"
                                    accept=".p12" maxFileSize={2000000}
                                    onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                                    headerTemplate={headerTemplate} itemTemplate={itemTemplate}
                                    emptyTemplate={emptyTemplate}
                                    chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} 
                                    contentClassName='p-2' className='p-0' style={{ padding: 0 }}
                                    headerClassName='p-2'
                                    chooseLabel='Agregar Certificado' 
                                />
                            </div>
                        </div>
                        <div className='flex flex-col md:flex-row gap-8 mt-2'>
                            <div className='flex flex-col gap-1 w-full'>
                                <p className='my-0'>Contrase&ntilde;a</p>
                                <div className='flex flex-col md:flex-row gap-1 md:gap-0'>
                                    <InputText className='focus:shadow-none rounded-r-none' 
                                        value={Keyvalue} disabled={successInCertificate}
                                        type='password'
                                        onChange={(e) => setKeyValue(e.target.value)} />
                                    <Button className='web-boton focus:shadow-none rounded-l-none'
                                        onClick={validarCertificado} disabled={checkingCertificate}
                                    >
                                        <i className='pi pi-file-check'></i>&nbsp;Validar
                                    </Button>
                                </div>
                            </div>
                        </div>
                        { checkingCertificate && errorInCertificate &&  <Message severity="error" text={msgError} /> }    
                        { checkingCertificate && successInCertificate && <Message className='flex' severity="success" text="Certificado y Password Validado." /> }
                    </div>
                    }
                </div>
            </Dialog>
        </UserContainerComponent>
    );

    function handleChange(event: React.FormEvent<HTMLInputElement>) {
        const input = event.currentTarget.value;
    
        if ( input === '' ) {
            setFilterCompanies(companies);
        } else {
            const data = companies.filter(datos => {
                return datos.name.toLowerCase().includes(input.toLowerCase())
            })
            setFilterCompanies(data);
        }
    }

    function checkCompany(id: number) {
        navigate('./data');
    }

    function prepararDatos(item: any) {
        // console.log(item);
        let dateTmp1: Date;
        let dateTmp2: Date;
        setNuevoReg(false)

        if ( item.dueDays === 999999 ) {
            setNuevoReg(true);
            dateTmp1 = new Date();
            dateTmp2 = new Date();
        } else {
            dateTmp1 = new Date(item.creationDate);
            dateTmp2 = new Date(item.dueDate);
        }

        setItemReg(item);
        setDate1(dateTmp1);
        setDate2(dateTmp2);

        setVisible(true);
    }

    function guardarDatos() {

        let dataEnvio = {
            creationDate : Utilidades.getStringOfDateStandard(date1),
            dueDate : Utilidades.getStringOfDateStandard(date2),
            id : itemReg.id
        };

        let token: string = String(localStorage.getItem('token'));

        if ( sendCertificate ) {
            setGuardando(true);
            cargarDataCertificado();
        } else {
            setGuardando(true);
            DataAPI.saveClientCertificate(token,dataEnvio).then((response) => {
                // console.log(response);
                if (response.resultado === 1) {
                    cargarCertificadosClientes();
                    setVisible(false);
                }
                setGuardando(false);
            });
        }
    }

    function cargarCertificadosClientes() {
        // console.log('cargarCertificadosClientes');
        setCargando(true);
        let token: string = String(localStorage.getItem('token'));
        
        DataAPI.getWorkingCompaniesCertList(token).then((data: any)=> {
            let noDefinidos: number = 0;
            let Vencidos: number = 0;
            let Venciendo: number = 0;
            let Activos: number = 0;

            let datos: Array<any> = data.objeto;
            datos.forEach(itemDB => {
                if ( itemDB.dueDays === 999999 ) 
                    noDefinidos += 1;
                else if( itemDB.dueDays <= 0  )
                    Vencidos += 1;
                else if( itemDB.dueDays <= 7  )
                    Venciendo += 1;
                else 
                    Activos += 1;
            });

            let dataResumen: Array<any> = [noDefinidos , Vencidos, Venciendo , Activos];
            setGrupos(dataResumen)

            // console.log(data);
            setCompanies(data.objeto);
            setFilterCompanies(data.objeto);
            setCargando(false);
            setEmptyTableLabel('No existen registros.');
        });
    }

    function validarCertificado() {
        if ( totalSize <= 0 ) {
            setCheckingCertificate(true);
            setErrorInCertificate(true);
            setMsgError('Debe seleccionar un archivo de firma a subir.');
            reiniciarRespuesta();
            return;
        }
        let token: string = String(localStorage.getItem('token'));
        const files = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.getFiles() : [];
        const file = files[0];
        // console.log(file);

        const formData = new FormData();
        formData.append('certificate', file, file.name); 
        formData.append('key', Keyvalue); 
        formData.append('token', token); 
        formData.append('id', itemReg.id); 
        
        setCheckingCertificate(true);
        DataAPI.checkClientCertificate(formData)
            .then((data) => {
            if (data.resultado === 1) {
                setSuccessInCertificate(true);
                reiniciarRespuesta();
            } else {
                setMsgError('Error al usar el certificado: '
                    + data.mensaje +'.');
                setErrorInCertificate(true);
                reiniciarRespuesta();
            }
        }).catch((error:any) => {
            console.error(error);
        });        
    }

    function reiniciarRespuesta() {
        setTimeout(() => {
            setErrorInCertificate(false);
            setCheckingCertificate(false);
            setMsgError('Error al usar el certificado.');
        }, 2500);
    }

    function cargarDataCertificado() {
        if ( totalSize <= 0 ) {
            setCheckingCertificate(true);
            setErrorInCertificate(true);
            setMsgError('Debe seleccionar un archivo de firma a subir.');
            reiniciarRespuesta();
            return;
        }
        let token: string = String(localStorage.getItem('token'));
        const files = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.getFiles() : [];
        const file = files[0];
        // console.log(file);

        const formData = new FormData();
        formData.append('certificate', file, file.name); 
        formData.append('key', Keyvalue); 
        formData.append('token', token); 
        formData.append('id', itemReg.id); 
        formData.append('creationDate', Utilidades.getStringOfDateStandard(date1));
        formData.append('dueDate', Utilidades.getStringOfDateStandard(date2));             
        
        // setCheckingCertificate(true);
        DataAPI.saveClientCertificateFile(formData)
            .then((data) => {
            if (data.resultado === 1) {
                setSendCertificate(false);
                setKeyValue('');
                onTemplateClear();
                cargarCertificadosClientes();
                setVisible(false);
            }
            setGuardando(false);
        }).catch((error:any) => {
            console.error(error);
        });        
    }
}

export default CertificatesView;